import React from "react";
import Box from "@material-ui/core/Box";
import LinearProgress from "@material-ui/core/LinearProgress";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles({
  root: {
    height: 8,
    borderRadius: 5
  },
  colorPrimary: props => ({
    backgroundColor: props.barBackgroundColor
  }),
  bar: props => ({
    backgroundColor: props.barColor,
    borderRadius: 5
  })
});

const LinearProgressWithLabel = ({ barBackgroundColor, barColor, qty, ...props }) => {
  const classes = useStyles({ barBackgroundColor, barColor });
  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <Box width="100%" display="flex" justifyContent="center">
        <Typography variant="body2" color="textSecondary">{`${Math.round(props.value)}%, ${qty || 0}`}</Typography>
      </Box>
      <Box width="100%">
        <LinearProgress classes={classes} variant="determinate"   {...props} value={props.value > 100 ? 100 : props.value} />
      </Box>
    </Box>
  );
};

export default LinearProgressWithLabel;
